import { ItemToProductCard } from '../../../../../components/Product/components/ProductCard/types/productCard.types';
import { transformCatalogSectionItemToProductCard } from '../../../../../components/Product/components/ProductCard/utils/mountItemToProductCard.utils';
import { ProductCardV2Props } from '../../../../../components/Product/components/ProductCardV2/types/productCardV2.types';
import LangEnum from '../../../../../lang/LangEnum';
import { ESProductCatalogSearch } from '../../product-catalog-es.types';
import { RowCard } from '../catalogProductsListV2.types';

export const buildProductCardItem = (
  card: Extract<RowCard, { kind: 'item' }>,
): ItemToProductCard => {
  const item = transformCatalogSectionItemToProductCard(card.esProduct.item);

  if (!card.canAddToOrder) {
    item.availableForSale = false;
  }

  return item;
};

export const buildProductCardProps = (
  card: Extract<RowCard, { kind: 'item' }>,
  catalogId: string,
): ProductCardV2Props => ({
  item: buildProductCardItem(card),
  catalogId,
  isSuggestedProduct: card.isSuggested,
  selloutMetrics: card.selloutMetrics,
  shoppingButtonTooltipMessage: card.canAddToOrder
    ? undefined
    : LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT,
});

export const getCatalogSelectionSectionProductId = ({
  id,
  catalogSectionProduct,
}: Pick<ESProductCatalogSearch, 'id' | 'catalogSectionProduct'>) => catalogSectionProduct?.id ?? id;
